var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fullScreenLoading,
          expression: "fullScreenLoading",
        },
      ],
      staticClass: "manager-container module-main-body",
    },
    [
      _c(
        "el-row",
        { staticClass: "module-content-top-bar" },
        [
          _c("el-col", { attrs: { md: 24, lg: 10 } }, [
            _c("h1", { staticClass: "top-bar-title" }, [
              _vm._v(_vm._s(_vm.contentTitle)),
            ]),
          ]),
          _c("el-col", { attrs: { md: 24, lg: 14 } }, [
            _c(
              "div",
              { staticClass: "button-bar" },
              [
                _c("el-button", { on: { click: _vm.toggleAllCheckboxes } }, [
                  _vm._v(_vm._s(_vm.allChecked ? "Uncheck All" : "Check All")),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "primary-button",
                    on: { click: _vm.handleSaveToList },
                  },
                  [_vm._v(" Save ")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      !_vm.fullScreenLoading
        ? _c(
            "el-row",
            {
              staticClass: "div-main-body-left-right module-content-main-view",
            },
            [
              _c(
                "el-col",
                {
                  staticClass: "left",
                  attrs: {
                    sm: _vm.hasSysAdminPermission ? 10 : 0,
                    md: _vm.hasSysAdminPermission ? 8 : 0,
                    lg: _vm.hasSysAdminPermission ? 5 : 0,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "title" },
                    [
                      _c("base-block-title", {
                        attrs: {
                          title: _vm.$t("company"),
                          "sub-title": _vm.companyList.length,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-divider", { staticClass: "el-divider" }),
                  _c(
                    "div",
                    { staticClass: "search-bar" },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "round-input",
                          attrs: { placeholder: "Search Company Name" },
                          nativeOn: {
                            keypress: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.onHandleSearch.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchKey,
                            callback: function ($$v) {
                              _vm.searchKey = $$v
                            },
                            expression: "searchKey",
                          },
                        },
                        [
                          !_vm.toggleIcon
                            ? _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  type: "primary",
                                  icon: "el-icon-search",
                                },
                                on: { click: _vm.onHandleSearch },
                                slot: "append",
                              })
                            : _vm._e(),
                          _vm.toggleIcon
                            ? _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  type: "primary",
                                  icon: "el-icon-close",
                                },
                                on: { click: _vm.onHandlClearSearch },
                                slot: "append",
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.companyList, function (item) {
                      return _c("company-item-new", {
                        key: item.id,
                        attrs: {
                          company: item,
                          currentCompany: _vm.currentCompany,
                          logoSrc: item.logoSrc,
                          showStatusTage: true,
                          active: item.id === _vm.currentCompany.id,
                        },
                        on: {
                          "update:logoSrc": function ($event) {
                            return _vm.$set(item, "logoSrc", $event)
                          },
                          "update:logo-src": function ($event) {
                            return _vm.$set(item, "logoSrc", $event)
                          },
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleCompanyClick(item)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.pageVisible && _vm.currentCompany.id
                ? _c(
                    "el-col",
                    {
                      staticClass: "right",
                      attrs: {
                        sm: _vm.hasSysAdminPermission ? 14 : 24,
                        md: _vm.hasSysAdminPermission ? 16 : 24,
                        lg: _vm.hasSysAdminPermission ? 19 : 24,
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          key: "tableKey",
                          ref: "productListRef",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.productList,
                            border: "",
                            "table-layout": "fixed",
                            "header-cell-style": _vm.HEADER_CELL_STYLE,
                            "cell-style": _vm.CELL_STYLE,
                            "row-key": "id",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "No.", width: "50" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scope.$index + 1) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3056706777
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "productName",
                              label: "Product Name",
                            },
                          }),
                          _vm.isMaersk
                            ? _c("el-table-column", {
                                staticStyle: { width: "100%", height: "28px" },
                                attrs: {
                                  prop: "customerProductName",
                                  label: "Customer Product Name",
                                  size: "mini",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              placeholder: "Enter name",
                                            },
                                            model: {
                                              value:
                                                scope.row.customerProductName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "customerProductName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.customerProductName",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3929237975
                                ),
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: { label: "Add to List" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        staticStyle: {
                                          "padding-right": "100%",
                                        },
                                        attrs: {
                                          "false-label": "0",
                                          "true-label": "1",
                                        },
                                        model: {
                                          value: scope.row.flag,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "flag", $$v)
                                          },
                                          expression: "scope.row.flag",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1891332475
                            ),
                          }),
                        ],
                        1
                      ),
                      !_vm.currentCompany.id ? _c("base-no-data") : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }